/*
import { Typography } from "@mui/material";

const AddStockItem = () => {
  return (
    <Typography variant="h4" sx={{ fontWeight: "bold" }} color="primary">
      Add Stock Item
    </Typography>
  );
};
export default AddStockItem;
*/
import React, { useState } from "react";
import CustomFormDialog from "../../Components/CustomFormDialog"; // Assuming the component is in the same directory
import { Button } from "@mui/material";

const AddStockItem = () => {
    const [open, setOpen] = useState(false);

    // Sample fields array
    const fields = [
        {
            label: "Name",
            name: "name",
            type: "text",
            placeholder: "Enter name",
            required: true,
            width: "49%",
            validate: (value) =>
                value.trim() === "" ? "Name is required" : "",
        },
        {
            label: "Email",
            name: "email",
            type: "email",
            required: true,
            width: "49%",
            validate: (value) =>
                /\S+@\S+\.\S+/.test(value) ? "" : "Invalid email format",
        },
        {
            label: "Category",
            name: "categoryId",
            type: "select",
            options: [
                { value: 0, label: "None" },
                { value: 1, label: "Category 1" },
                { value: 2, label: "Category 2" },
                { value: 3, label: "Category 3" },
            ],
            required: true,
        },
        {
            label: "Type",
            name: "type",
            type: "radio",
            options: [
                { value: 1, label: "Type 1" },
                { value: 2, label: "Type 2" },
            ],
            required: true,
        },
        {
            label: "Active",
            name: "active",
            type: "checkbox",
            required: false,
            checked: true,
        },
        {
            label: "Phone",
            name: "phone",
            type: "number",
            required: false,
            validate: (value) =>
                value.length >= 10 ? "" : "Phone must be at least 10 digits",
        },
    ];

    const handleSubmitClick = (formData) => {
        setOpen(false); // Close the dialog after submission
    };

    const handleOpenDialog = () => {
        setOpen(true);
    };

    const handleCloseDialog = () => {
        setOpen(false);
    };

    return (
        <div>
            <h1>Sample Form with CustomFormDialog</h1>
            <Button
                variant="contained"
                color="primary"
                onClick={handleOpenDialog}
            >
                Open Form Dialog
            </Button>

            <CustomFormDialog
                title="Sample Form"
                fields={fields}
                open={open}
                onClose={handleCloseDialog}
                formSubmitText="Submit"
                handleSubmitClick={handleSubmitClick}
            />
        </div>
    );
};

export default AddStockItem;
